import angular from "angular";
import { FormViewController } from "./controller";

export const vsComponentName = "recordFormView";

export const formViewComponentOptions: angular.IComponentOptions = {
  controller: FormViewController,
  controllerAs: "formViewController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    fields: "<",
    model: "<",
    title: "@",
    onSubmit: "&",
    onCancel: "&",
    showButtonsAtTop: "<?",
  },
};
